// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProjectTwoToneSvg from "@ant-design/icons-svg/es/asn/ProjectTwoTone";
import AntdIcon from '../components/AntdIcon';

var ProjectTwoTone = function ProjectTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ProjectTwoToneSvg
  }));
};

ProjectTwoTone.displayName = 'ProjectTwoTone';
export default React.forwardRef(ProjectTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ProjectTwoTone.js
// module id = 1629
// module chunks = 0